// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_CancelResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for invoice cancellation
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Invoice_CancelResponseDados {
invoice_id?: number
status?: string
}

export type Invoice_CancelResponse = ApiResponse<Invoice_CancelResponseDados>;

registerResponseContract('Invoice_CancelResponse', {
  invoice_id: { type: 'number',  required: false },
  status:     { type: 'string',  required: false },
})
